export function savedResultUrl(item) {
  const value=item?.resultUrl || item?.sourceUrl || '';
  if(value.startsWith('blob:') && item?.transientResult)return value;
  try {const u=new URL(value);return u.protocol==='https:' && u.hostname==='media.pollinations.ai' && !u.username && !u.password && !u.searchParams.has('key') ? u.toString() : '';}catch{return '';}
}
function clean(value) {
  if(Array.isArray(value))return value.map(clean);
  if(value && typeof value==='object')return Object.fromEntries(Object.entries(value).filter(([key])=>!['apiKey','key','authorization','referenceImageDataUrl','referenceFile','_brandProfile','referencePalette','referenceVibe'].includes(key)).map(([key,v])=>[key,clean(v)]));
  return value;
}
export function sanitizeHistoryItem(item) {
  const safe=clean(item);const url=savedResultUrl({...item,transientResult:false});
  return {...safe,sourceUrl:url,resultUrl:url,transientResult:false};
}
